import { Gift } from "lucide-react";
import { TID } from "@/constants/testIds";

export const ReferralBanner = () => (
  <div
    data-testid={TID.referralBanner}
    className="bg-[#D4AF37] text-black text-xs sm:text-sm font-semibold py-2 px-4 text-center relative overflow-hidden"
  >
    <div className="absolute inset-0 shimmer pointer-events-none" />
    <div className="relative flex items-center justify-center gap-2 flex-wrap">
      <Gift size={14} strokeWidth={2} />
      <span className="tracking-wide uppercase">$100 for every successful referral</span>
      <span className="hidden sm:inline opacity-70">·</span>
      <a href="#referrals" className="underline underline-offset-2 hover:opacity-80">Learn More</a>
    </div>
  </div>
);
